import { useState, useEffect } from 'react';

const SITE_URL = 'https://hoosierlifeinsurance.com';

type RateRow = { carrier: string; amBest: string; rate10: string; rate20: string; rate30: string; specialty: string };

const rateData: Record<string, Record<string, Record<string, RateRow[]>>> = {
  '25': {
    '250000': {
      male: [
        { carrier: 'Banner Life', amBest: 'A+', rate10: '$9/mo', rate20: '$12/mo', rate30: '$16/mo', specialty: 'Best overall value' },
        { carrier: 'Pacific Life', amBest: 'A+', rate10: '$10/mo', rate20: '$13/mo', rate30: '$17/mo', specialty: 'Strong financials' },
        { carrier: 'Protective Life', amBest: 'A+', rate10: '$10/mo', rate20: '$13/mo', rate30: '$18/mo', specialty: 'No-lapse guarantee' },
        { carrier: 'North American', amBest: 'A+', rate10: '$11/mo', rate20: '$14/mo', rate30: '$19/mo', specialty: 'Living benefits' },
        { carrier: 'Mutual of Omaha', amBest: 'A+', rate10: '$11/mo', rate20: '$15/mo', rate30: '$20/mo', specialty: 'Conversion options' },
      ],
      female: [
        { carrier: 'Banner Life', amBest: 'A+', rate10: '$8/mo', rate20: '$10/mo', rate30: '$14/mo', specialty: 'Best overall value' },
        { carrier: 'Pacific Life', amBest: 'A+', rate10: '$9/mo', rate20: '$11/mo', rate30: '$15/mo', specialty: 'Strong financials' },
        { carrier: 'Protective Life', amBest: 'A+', rate10: '$9/mo', rate20: '$12/mo', rate30: '$16/mo', specialty: 'No-lapse guarantee' },
        { carrier: 'North American', amBest: 'A+', rate10: '$10/mo', rate20: '$12/mo', rate30: '$17/mo', specialty: 'Living benefits' },
        { carrier: 'Mutual of Omaha', amBest: 'A+', rate10: '$10/mo', rate20: '$13/mo', rate30: '$18/mo', specialty: 'Conversion options' },
      ],
    },
    '500000': {
      male: [
        { carrier: 'Banner Life', amBest: 'A+', rate10: '$14/mo', rate20: '$20/mo', rate30: '$28/mo', specialty: 'Best overall value' },
        { carrier: 'Pacific Life', amBest: 'A+', rate10: '$15/mo', rate20: '$21/mo', rate30: '$29/mo', specialty: 'Strong financials' },
        { carrier: 'Protective Life', amBest: 'A+', rate10: '$15/mo', rate20: '$22/mo', rate30: '$30/mo', specialty: 'No-lapse guarantee' },
        { carrier: 'North American', amBest: 'A+', rate10: '$16/mo', rate20: '$23/mo', rate30: '$32/mo', specialty: 'Living benefits' },
        { carrier: 'Mutual of Omaha', amBest: 'A+', rate10: '$17/mo', rate20: '$24/mo', rate30: '$33/mo', specialty: 'Conversion options' },
      ],
      female: [
        { carrier: 'Banner Life', amBest: 'A+', rate10: '$12/mo', rate20: '$17/mo', rate30: '$24/mo', specialty: 'Best overall value' },
        { carrier: 'Pacific Life', amBest: 'A+', rate10: '$13/mo', rate20: '$18/mo', rate30: '$25/mo', specialty: 'Strong financials' },
        { carrier: 'Protective Life', amBest: 'A+', rate10: '$13/mo', rate20: '$19/mo', rate30: '$26/mo', specialty: 'No-lapse guarantee' },
        { carrier: 'North American', amBest: 'A+', rate10: '$14/mo', rate20: '$20/mo', rate30: '$28/mo', specialty: 'Living benefits' },
        { carrier: 'Mutual of Omaha', amBest: 'A+', rate10: '$15/mo', rate20: '$21/mo', rate30: '$29/mo', specialty: 'Conversion options' },
      ],
    },
    '1000000': {
      male: [
        { carrier: 'Banner Life', amBest: 'A+', rate10: '$24/mo', rate20: '$36/mo', rate30: '$52/mo', specialty: 'Best overall value' },
        { carrier: 'Pacific Life', amBest: 'A+', rate10: '$25/mo', rate20: '$38/mo', rate30: '$54/mo', specialty: 'Strong financials' },
        { carrier: 'Protective Life', amBest: 'A+', rate10: '$26/mo', rate20: '$39/mo', rate30: '$56/mo', specialty: 'No-lapse guarantee' },
        { carrier: 'North American', amBest: 'A+', rate10: '$27/mo', rate20: '$41/mo', rate30: '$58/mo', specialty: 'Living benefits' },
        { carrier: 'Mutual of Omaha', amBest: 'A+', rate10: '$28/mo', rate20: '$43/mo', rate30: '$61/mo', specialty: 'Conversion options' },
      ],
      female: [
        { carrier: 'Banner Life', amBest: 'A+', rate10: '$20/mo', rate20: '$30/mo', rate30: '$44/mo', specialty: 'Best overall value' },
        { carrier: 'Pacific Life', amBest: 'A+', rate10: '$21/mo', rate20: '$32/mo', rate30: '$46/mo', specialty: 'Strong financials' },
        { carrier: 'Protective Life', amBest: 'A+', rate10: '$22/mo', rate20: '$33/mo', rate30: '$48/mo', specialty: 'No-lapse guarantee' },
        { carrier: 'North American', amBest: 'A+', rate10: '$23/mo', rate20: '$35/mo', rate30: '$50/mo', specialty: 'Living benefits' },
        { carrier: 'Mutual of Omaha', amBest: 'A+', rate10: '$24/mo', rate20: '$37/mo', rate30: '$52/mo', specialty: 'Conversion options' },
      ],
    },
  },
  '35': {
    '250000': {
      male: [
        { carrier: 'Banner Life', amBest: 'A+', rate10: '$11/mo', rate20: '$15/mo', rate30: '$22/mo', specialty: 'Best overall value' },
        { carrier: 'Pacific Life', amBest: 'A+', rate10: '$12/mo', rate20: '$16/mo', rate30: '$23/mo', specialty: 'Strong financials' },
        { carrier: 'Protective Life', amBest: 'A+', rate10: '$12/mo', rate20: '$17/mo', rate30: '$24/mo', specialty: 'No-lapse guarantee' },
        { carrier: 'North American', amBest: 'A+', rate10: '$13/mo', rate20: '$18/mo', rate30: '$26/mo', specialty: 'Living benefits' },
        { carrier: 'Mutual of Omaha', amBest: 'A+', rate10: '$14/mo', rate20: '$19/mo', rate30: '$27/mo', specialty: 'Conversion options' },
      ],
      female: [
        { carrier: 'Banner Life', amBest: 'A+', rate10: '$10/mo', rate20: '$13/mo', rate30: '$19/mo', specialty: 'Best overall value' },
        { carrier: 'Pacific Life', amBest: 'A+', rate10: '$11/mo', rate20: '$14/mo', rate30: '$20/mo', specialty: 'Strong financials' },
        { carrier: 'Protective Life', amBest: 'A+', rate10: '$11/mo', rate20: '$15/mo', rate30: '$21/mo', specialty: 'No-lapse guarantee' },
        { carrier: 'North American', amBest: 'A+', rate10: '$12/mo', rate20: '$16/mo', rate30: '$22/mo', specialty: 'Living benefits' },
        { carrier: 'Mutual of Omaha', amBest: 'A+', rate10: '$12/mo', rate20: '$17/mo', rate30: '$23/mo', specialty: 'Conversion options' },
      ],
    },
    '500000': {
      male: [
        { carrier: 'Banner Life', amBest: 'A+', rate10: '$18/mo', rate20: '$26/mo', rate30: '$38/mo', specialty: 'Best overall value' },
        { carrier: 'Pacific Life', amBest: 'A+', rate10: '$19/mo', rate20: '$27/mo', rate30: '$40/mo', specialty: 'Strong financials' },
        { carrier: 'Protective Life', amBest: 'A+', rate10: '$20/mo', rate20: '$28/mo', rate30: '$42/mo', specialty: 'No-lapse guarantee' },
        { carrier: 'North American', amBest: 'A+', rate10: '$21/mo', rate20: '$30/mo', rate30: '$44/mo', specialty: 'Living benefits' },
        { carrier: 'Mutual of Omaha', amBest: 'A+', rate10: '$22/mo', rate20: '$31/mo', rate30: '$46/mo', specialty: 'Conversion options' },
      ],
      female: [
        { carrier: 'Banner Life', amBest: 'A+', rate10: '$15/mo', rate20: '$22/mo', rate30: '$32/mo', specialty: 'Best overall value' },
        { carrier: 'Pacific Life', amBest: 'A+', rate10: '$16/mo', rate20: '$23/mo', rate30: '$33/mo', specialty: 'Strong financials' },
        { carrier: 'Protective Life', amBest: 'A+', rate10: '$17/mo', rate20: '$24/mo', rate30: '$35/mo', specialty: 'No-lapse guarantee' },
        { carrier: 'North American', amBest: 'A+', rate10: '$18/mo', rate20: '$25/mo', rate30: '$37/mo', specialty: 'Living benefits' },
        { carrier: 'Mutual of Omaha', amBest: 'A+', rate10: '$19/mo', rate20: '$26/mo', rate30: '$38/mo', specialty: 'Conversion options' },
      ],
    },
    '1000000': {
      male: [
        { carrier: 'Banner Life', amBest: 'A+', rate10: '$32/mo', rate20: '$48/mo', rate30: '$70/mo', specialty: 'Best overall value' },
        { carrier: 'Pacific Life', amBest: 'A+', rate10: '$34/mo', rate20: '$50/mo', rate30: '$73/mo', specialty: 'Strong financials' },
        { carrier: 'Protective Life', amBest: 'A+', rate10: '$35/mo', rate20: '$52/mo', rate30: '$76/mo', specialty: 'No-lapse guarantee' },
        { carrier: 'North American', amBest: 'A+', rate10: '$37/mo', rate20: '$55/mo', rate30: '$80/mo', specialty: 'Living benefits' },
        { carrier: 'Mutual of Omaha', amBest: 'A+', rate10: '$38/mo', rate20: '$57/mo', rate30: '$83/mo', specialty: 'Conversion options' },
      ],
      female: [
        { carrier: 'Banner Life', amBest: 'A+', rate10: '$27/mo', rate20: '$40/mo', rate30: '$59/mo', specialty: 'Best overall value' },
        { carrier: 'Pacific Life', amBest: 'A+', rate10: '$28/mo', rate20: '$42/mo', rate30: '$61/mo', specialty: 'Strong financials' },
        { carrier: 'Protective Life', amBest: 'A+', rate10: '$29/mo', rate20: '$44/mo', rate30: '$64/mo', specialty: 'No-lapse guarantee' },
        { carrier: 'North American', amBest: 'A+', rate10: '$31/mo', rate20: '$46/mo', rate30: '$67/mo', specialty: 'Living benefits' },
        { carrier: 'Mutual of Omaha', amBest: 'A+', rate10: '$32/mo', rate20: '$48/mo', rate30: '$70/mo', specialty: 'Conversion options' },
      ],
    },
  },
  '45': {
    '250000': {
      male: [
        { carrier: 'Banner Life', amBest: 'A+', rate10: '$20/mo', rate20: '$32/mo', rate30: '$52/mo', specialty: 'Best overall value' },
        { carrier: 'Pacific Life', amBest: 'A+', rate10: '$21/mo', rate20: '$34/mo', rate30: '$55/mo', specialty: 'Strong financials' },
        { carrier: 'Protective Life', amBest: 'A+', rate10: '$22/mo', rate20: '$35/mo', rate30: '$57/mo', specialty: 'No-lapse guarantee' },
        { carrier: 'North American', amBest: 'A+', rate10: '$23/mo', rate20: '$37/mo', rate30: '$60/mo', specialty: 'Living benefits' },
        { carrier: 'Mutual of Omaha', amBest: 'A+', rate10: '$24/mo', rate20: '$39/mo', rate30: '$63/mo', specialty: 'Conversion options' },
      ],
      female: [
        { carrier: 'Banner Life', amBest: 'A+', rate10: '$16/mo', rate20: '$26/mo', rate30: '$43/mo', specialty: 'Best overall value' },
        { carrier: 'Pacific Life', amBest: 'A+', rate10: '$17/mo', rate20: '$27/mo', rate30: '$45/mo', specialty: 'Strong financials' },
        { carrier: 'Protective Life', amBest: 'A+', rate10: '$18/mo', rate20: '$28/mo', rate30: '$47/mo', specialty: 'No-lapse guarantee' },
        { carrier: 'North American', amBest: 'A+', rate10: '$19/mo', rate20: '$30/mo', rate30: '$49/mo', specialty: 'Living benefits' },
        { carrier: 'Mutual of Omaha', amBest: 'A+', rate10: '$20/mo', rate20: '$31/mo', rate30: '$51/mo', specialty: 'Conversion options' },
      ],
    },
    '500000': {
      male: [
        { carrier: 'Banner Life', amBest: 'A+', rate10: '$36/mo', rate20: '$58/mo', rate30: '$96/mo', specialty: 'Best overall value' },
        { carrier: 'Pacific Life', amBest: 'A+', rate10: '$38/mo', rate20: '$61/mo', rate30: '$100/mo', specialty: 'Strong financials' },
        { carrier: 'Protective Life', amBest: 'A+', rate10: '$39/mo', rate20: '$63/mo', rate30: '$104/mo', specialty: 'No-lapse guarantee' },
        { carrier: 'North American', amBest: 'A+', rate10: '$41/mo', rate20: '$66/mo', rate30: '$109/mo', specialty: 'Living benefits' },
        { carrier: 'Mutual of Omaha', amBest: 'A+', rate10: '$43/mo', rate20: '$69/mo', rate30: '$114/mo', specialty: 'Conversion options' },
      ],
      female: [
        { carrier: 'Banner Life', amBest: 'A+', rate10: '$29/mo', rate20: '$47/mo', rate30: '$79/mo', specialty: 'Best overall value' },
        { carrier: 'Pacific Life', amBest: 'A+', rate10: '$31/mo', rate20: '$49/mo', rate30: '$82/mo', specialty: 'Strong financials' },
        { carrier: 'Protective Life', amBest: 'A+', rate10: '$32/mo', rate20: '$51/mo', rate30: '$85/mo', specialty: 'No-lapse guarantee' },
        { carrier: 'North American', amBest: 'A+', rate10: '$34/mo', rate20: '$54/mo', rate30: '$89/mo', specialty: 'Living benefits' },
        { carrier: 'Mutual of Omaha', amBest: 'A+', rate10: '$35/mo', rate20: '$56/mo', rate30: '$93/mo', specialty: 'Conversion options' },
      ],
    },
    '1000000': {
      male: [
        { carrier: 'Banner Life', amBest: 'A+', rate10: '$68/mo', rate20: '$110/mo', rate30: '$184/mo', specialty: 'Best overall value' },
        { carrier: 'Pacific Life', amBest: 'A+', rate10: '$71/mo', rate20: '$115/mo', rate30: '$192/mo', specialty: 'Strong financials' },
        { carrier: 'Protective Life', amBest: 'A+', rate10: '$74/mo', rate20: '$120/mo', rate30: '$200/mo', specialty: 'No-lapse guarantee' },
        { carrier: 'North American', amBest: 'A+', rate10: '$77/mo', rate20: '$126/mo', rate30: '$210/mo', specialty: 'Living benefits' },
        { carrier: 'Mutual of Omaha', amBest: 'A+', rate10: '$80/mo', rate20: '$132/mo', rate30: '$220/mo', specialty: 'Conversion options' },
      ],
      female: [
        { carrier: 'Banner Life', amBest: 'A+', rate10: '$55/mo', rate20: '$89/mo', rate30: '$150/mo', specialty: 'Best overall value' },
        { carrier: 'Pacific Life', amBest: 'A+', rate10: '$58/mo', rate20: '$93/mo', rate30: '$157/mo', specialty: 'Strong financials' },
        { carrier: 'Protective Life', amBest: 'A+', rate10: '$60/mo', rate20: '$97/mo', rate30: '$163/mo', specialty: 'No-lapse guarantee' },
        { carrier: 'North American', amBest: 'A+', rate10: '$63/mo', rate20: '$102/mo', rate30: '$171/mo', specialty: 'Living benefits' },
        { carrier: 'Mutual of Omaha', amBest: 'A+', rate10: '$66/mo', rate20: '$107/mo', rate30: '$179/mo', specialty: 'Conversion options' },
      ],
    },
  },
};

const faqs = [
  { q: 'What are the current term life insurance rates in Indianapolis?', a: 'A healthy 35-year-old male in Indianapolis can get $500,000 of 20-year term life insurance for as little as $26/month. Rates vary by age, gender, health class, coverage amount, and term length. Use our rate table above to see current rates.' },
  { q: 'Which carrier has the lowest term life insurance rates in Indianapolis?', a: 'Banner Life and Pacific Life consistently offer the lowest term life insurance rates in Indianapolis for preferred health classes. However, the best carrier for you depends on your specific age, health, and coverage needs. We compare all carriers to find your lowest rate.' },
  { q: 'How do term life insurance rates change with age in Indianapolis?', a: 'Rates increase significantly with age. A $500,000 20-year term policy costs approximately $26/month at age 35, $58/month at age 45, and $130+/month at age 55. Locking in your rate now saves thousands over the life of the policy.' },
  { q: 'Do women pay less for term life insurance than men in Indianapolis?', a: 'Yes. Women statistically live longer, so they pay 15–25% less for term life insurance than men of the same age and health class. A 35-year-old woman pays approximately $22/month for $500,000 of 20-year term coverage.' },
  { q: 'What health class do I need for the lowest term life insurance rates?', a: 'Preferred Plus (or Super Preferred) is the top health class and gets the lowest rates. To qualify, you typically need no major health conditions, healthy BMI, no tobacco use, and a clean family history. Most healthy adults qualify for Preferred or Standard Plus.' },
  { q: 'How long does it take to get approved for term life insurance in Indianapolis?', a: 'Many carriers now offer accelerated underwriting with no medical exam — approval in 24–72 hours. Traditional underwriting with a medical exam takes 3–6 weeks. We match you with the fastest carrier for your situation.' },
  { q: 'Can I lock in my term life insurance rate in Indianapolis?', a: 'Yes. Once your policy is issued, your premium is locked in for the entire term — 10, 20, or 30 years. Your rate will never increase, regardless of any health changes during the term.' },
  { q: 'Is a 20-year or 30-year term better for Indianapolis families?', a: 'A 20-year term is most popular for families with young children — it covers the years when your income is most needed. A 30-year term is better if you have a 30-year mortgage or want coverage until retirement. We\'ll help you choose the right term.' },
];

export default function TermLifeInsuranceRatesIndianapolisPage() {
  const [age, setAge] = useState('35');
  const [coverage, setCoverage] = useState('500000');
  const [gender, setGender] = useState('male');
  const [showTable, setShowTable] = useState(false);
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  useEffect(() => {
    document.title = 'Term Life Insurance Rates Indianapolis IN | 2026 Rate Table by Age | Hoosier Life';
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute('content', 'Term life insurance rates in Indianapolis, Indiana. 2026 rate table by age, term, and coverage amount. Side-by-side carrier breakdown. Compare 20+ carriers — free quotes for Indianapolis residents.');
    const canonical = document.querySelector('link[rel="canonical"]') || document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    canonical.setAttribute('href', `${SITE_URL}/term-life-insurance-rates-indianapolis`);
    if (!document.querySelector('link[rel="canonical"]')) document.head.appendChild(canonical);

    const schema = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'WebPage',
          '@id': `${SITE_URL}/term-life-insurance-rates-indianapolis#webpage`,
          url: `${SITE_URL}/term-life-insurance-rates-indianapolis`,
          name: 'Term Life Insurance Rates Indianapolis IN | 2026 Rate Table by Age | Hoosier Life',
          description: 'Term life insurance rates in Indianapolis, Indiana. 2026 rate table by age, term, and coverage amount.',
          dateModified: '2026-04-15',
        },
        {
          '@type': 'FAQPage',
          mainEntity: faqs.map(f => ({ '@type': 'Question', name: f.q, acceptedAnswer: { '@type': 'Answer', text: f.a } })),
        },
      ],
    };
    const existing = document.getElementById('rates-indy-schema');
    if (existing) existing.remove();
    const script = document.createElement('script');
    script.id = 'rates-indy-schema';
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
    return () => { script.remove(); };
  }, []);

  const currentRates = rateData[age]?.[coverage]?.[gender] || [];

  const handleShowRates = () => setShowTable(true);

  const coverageLabels: Record<string, string> = { '250000': '$250,000', '500000': '$500,000', '1000000': '$1,000,000' };

  return (
    <div className="min-h-screen bg-white font-sans">
      {/* Hero */}
      <section className="relative pt-28 pb-20 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/df49248844506a999f858df756812fdb.jpg"
            alt="Term life insurance rates comparison in Indianapolis Indiana"
            className="w-full h-full object-cover object-top"
            width={1440}
            height={700}
            loading="eager"
            fetchPriority="high"
            decoding="async"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0F2A3F]/92 via-[#1A3A52]/82 to-[#0F2A3F]/65"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-8">
          <nav className="flex items-center gap-2 text-sm text-white/60 mb-8">
            <a href="/" className="hover:text-white transition-colors">Home</a>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-white">Term Life Insurance Rates Indianapolis</span>
          </nav>
          <div className="max-w-3xl">
            <span className="inline-flex items-center gap-2 px-3 py-1.5 bg-[#D97642]/25 text-[#F0A070] text-xs font-bold uppercase tracking-widest rounded-full border border-[#D97642]/40 mb-5">
              <i className="ri-bar-chart-line"></i>
              2026 Rate Table · Indianapolis, Indiana
            </span>
            <h1 className="text-4xl sm:text-5xl md:text-[56px] font-extrabold text-white leading-[1.1] mb-6">
              2026 Term Life Insurance Rates<br />
              <span className="text-[#F0A070]">for Indianapolis Families</span>
            </h1>
            <p className="text-lg text-white/80 leading-relaxed mb-8 max-w-2xl">
              2026 rate table by age, term length, and coverage amount. Side-by-side carrier breakdown from 5 top-rated companies. See exactly what Indianapolis residents pay — then get your personalized quote free.
            </p>
            <div className="flex flex-wrap gap-4 mb-8">
              {[
                { icon: 'ri-bar-chart-line', label: '2026 Rates' },
                { icon: 'ri-shield-check-line', label: '5 Carriers Compared' },
                { icon: 'ri-timer-flash-line', label: 'Preferred Health Class' },
                { icon: 'ri-map-pin-line', label: 'Indianapolis, Indiana' },
              ].map(b => (
                <div key={b.label} className="flex items-center gap-2 px-3 py-2 bg-white/10 rounded-lg border border-white/20 backdrop-blur-sm">
                  <i className={`${b.icon} text-[#D97642] text-sm`}></i>
                  <span className="text-sm text-white/90 font-medium">{b.label}</span>
                </div>
              ))}
            </div>
            <div className="flex flex-col sm:flex-row gap-4">
              <a href="/book-appointment" className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-[#D97642] text-white font-bold rounded-full hover:bg-[#C26638] transition-all whitespace-nowrap">
                <i className="ri-calendar-check-fill text-lg"></i>
                Get My Personalized Rate
              </a>
              <a href="tel:+13176482983" className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white/10 text-white font-bold rounded-full hover:bg-white/20 transition-all border border-white/30 whitespace-nowrap">
                <i className="ri-phone-fill text-lg"></i>
                (317) 648-2983
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Rate Table Tool */}
      <section className="py-20 bg-[#F9F7F4]">
        <div className="max-w-5xl mx-auto px-4 sm:px-8">
          <div className="text-center mb-10">
            <span className="inline-block px-4 py-1.5 bg-[#D97642]/15 text-[#D97642] text-xs font-bold uppercase tracking-widest rounded-full mb-4">2026 Rate Table</span>
            <h2 className="text-3xl md:text-4xl font-extrabold text-[#1A3A52] mb-4">Indianapolis Term Life Rate Comparison</h2>
            <p className="text-gray-600 max-w-xl mx-auto">Select your age, coverage amount, and gender to see a side-by-side carrier breakdown with 10, 20, and 30-year term rates.</p>
          </div>

          <div className="bg-white rounded-2xl p-8 border border-gray-100">
            {/* Filters */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-6">
              <div>
                <label className="block text-sm font-bold text-[#1A3A52] mb-3">Your Age</label>
                <div className="grid grid-cols-3 gap-2">
                  {['25', '35', '45'].map(a => (
                    <button key={a} onClick={() => { setAge(a); setShowTable(false); }}
                      className={`py-2.5 rounded-lg text-sm font-semibold border-2 transition-all cursor-pointer whitespace-nowrap ${age === a ? 'border-[#D97642] bg-[#D97642]/10 text-[#D97642]' : 'border-gray-200 text-gray-600 hover:border-[#D97642]/50'}`}>
                      Age {a}
                    </button>
                  ))}
                </div>
              </div>
              <div>
                <label className="block text-sm font-bold text-[#1A3A52] mb-3">Coverage Amount</label>
                <div className="grid grid-cols-1 gap-2">
                  {[{ v: '250000', l: '$250,000' }, { v: '500000', l: '$500,000' }, { v: '1000000', l: '$1,000,000' }].map(opt => (
                    <button key={opt.v} onClick={() => { setCoverage(opt.v); setShowTable(false); }}
                      className={`py-2.5 rounded-lg text-sm font-semibold border-2 transition-all cursor-pointer whitespace-nowrap ${coverage === opt.v ? 'border-[#D97642] bg-[#D97642]/10 text-[#D97642]' : 'border-gray-200 text-gray-600 hover:border-[#D97642]/50'}`}>
                      {opt.l}
                    </button>
                  ))}
                </div>
              </div>
              <div>
                <label className="block text-sm font-bold text-[#1A3A52] mb-3">Gender</label>
                <div className="grid grid-cols-2 gap-2">
                  {[{ v: 'male', l: 'Male' }, { v: 'female', l: 'Female' }].map(opt => (
                    <button key={opt.v} onClick={() => { setGender(opt.v); setShowTable(false); }}
                      className={`py-2.5 rounded-lg text-sm font-semibold border-2 transition-all cursor-pointer whitespace-nowrap ${gender === opt.v ? 'border-[#D97642] bg-[#D97642]/10 text-[#D97642]' : 'border-gray-200 text-gray-600 hover:border-[#D97642]/50'}`}>
                      {opt.l}
                    </button>
                  ))}
                </div>
                <div className="mt-3 p-3 bg-[#F9F7F4] rounded-lg">
                  <p className="text-xs text-gray-500">Rates shown are for <strong>Preferred health class</strong> — non-smoker, healthy BMI, no major conditions.</p>
                </div>
              </div>
            </div>

            <button onClick={handleShowRates}
              className="w-full py-4 bg-[#D97642] text-white font-bold rounded-xl hover:bg-[#C26638] transition-all cursor-pointer whitespace-nowrap text-base">
              <i className="ri-bar-chart-line mr-2"></i>
              Show {coverageLabels[coverage]} Rate Table — Age {age}
            </button>

            {showTable && currentRates.length > 0 && (
              <div className="mt-8">
                <div className="flex items-center gap-2 mb-4">
                  <i className="ri-checkbox-circle-fill text-green-500 text-xl"></i>
                  <h3 className="text-base font-bold text-[#1A3A52]">
                    {coverageLabels[coverage]} · Age {age} · {gender === 'male' ? 'Male' : 'Female'} · Preferred Health Class
                  </h3>
                </div>
                <div className="overflow-x-auto rounded-xl border border-gray-100">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="bg-[#1A3A52] text-white">
                        <th className="px-4 py-3.5 text-left font-bold">Carrier</th>
                        <th className="px-4 py-3.5 text-left font-bold">AM Best</th>
                        <th className="px-4 py-3.5 text-center font-bold">10-Year Term</th>
                        <th className="px-4 py-3.5 text-center font-bold">20-Year Term</th>
                        <th className="px-4 py-3.5 text-center font-bold">30-Year Term</th>
                        <th className="px-4 py-3.5 text-left font-bold hidden md:table-cell">Specialty</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentRates.map((row, i) => (
                        <tr key={row.carrier} className={`${i === 0 ? 'bg-[#FFF5EF]' : i % 2 === 0 ? 'bg-white' : 'bg-[#F9F7F4]'}`}>
                          <td className="px-4 py-4">
                            <div className="font-bold text-[#1A3A52]">{row.carrier}</div>
                            {i === 0 && <span className="text-xs text-[#D97642] font-bold">Lowest Rate</span>}
                          </td>
                          <td className="px-4 py-4 text-green-600 font-bold">{row.amBest}</td>
                          <td className="px-4 py-4 text-center font-bold text-[#1A3A52]">{row.rate10}</td>
                          <td className={`px-4 py-4 text-center font-bold ${i === 0 ? 'text-[#D97642] text-base' : 'text-[#1A3A52]'}`}>{row.rate20}</td>
                          <td className="px-4 py-4 text-center font-bold text-[#1A3A52]">{row.rate30}</td>
                          <td className="px-4 py-4 hidden md:table-cell">
                            <span className="px-2.5 py-1 bg-[#D97642]/10 text-[#D97642] text-xs font-semibold rounded-full">{row.specialty}</span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <p className="text-xs text-gray-400 mt-3">Rates are estimates for Preferred health class, non-smoker. Actual rates may vary. Last updated April 2026.</p>
                <div className="mt-5 p-4 bg-[#1A3A52] rounded-xl text-center">
                  <p className="text-white text-sm mb-3">Get your exact personalized rate — we compare all 20+ carriers, not just these 5.</p>
                  <a href="/book-appointment" className="inline-flex items-center gap-2 px-6 py-3 bg-[#D97642] text-white font-bold rounded-lg hover:bg-[#C26638] transition-all whitespace-nowrap">
                    <i className="ri-calendar-check-fill"></i>
                    Get My Exact Indianapolis Rate
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Rate by Age Summary Table */}
      <section className="py-20 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-8">
          <div className="text-center mb-10">
            <h2 className="text-3xl md:text-4xl font-extrabold text-[#1A3A52] mb-4">$500,000 Term Life Rates by Age — Indianapolis 2026</h2>
            <p className="text-gray-600">Preferred health class · Male · Non-smoker · Lowest available carrier rate</p>
          </div>
          <div className="overflow-x-auto rounded-2xl border border-gray-100">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-[#1A3A52] text-white">
                  <th className="px-5 py-4 text-left font-bold">Age</th>
                  <th className="px-5 py-4 text-center font-bold">10-Year Term</th>
                  <th className="px-5 py-4 text-center font-bold">20-Year Term</th>
                  <th className="px-5 py-4 text-center font-bold">30-Year Term</th>
                  <th className="px-5 py-4 text-left font-bold">Annual Savings vs. Age 45</th>
                </tr>
              </thead>
              <tbody>
                {[
                  { age: 25, r10: '$14/mo', r20: '$20/mo', r30: '$28/mo', savings: 'Save $456/yr vs. age 45' },
                  { age: 30, r10: '$15/mo', r20: '$22/mo', r30: '$31/mo', savings: 'Save $432/yr vs. age 45' },
                  { age: 35, r10: '$18/mo', r20: '$26/mo', r30: '$38/mo', savings: 'Save $384/yr vs. age 45' },
                  { age: 40, r10: '$26/mo', r20: '$40/mo', r30: '$62/mo', savings: 'Save $216/yr vs. age 45' },
                  { age: 45, r10: '$36/mo', r20: '$58/mo', r30: '$96/mo', savings: '—' },
                  { age: 50, r10: '$58/mo', r20: '$94/mo', r30: '$158/mo', savings: 'Costs $432/yr more' },
                  { age: 55, r10: '$96/mo', r20: '$158/mo', r30: 'N/A', savings: 'Costs $1,200/yr more' },
                ].map((row, i) => (
                  <tr key={row.age} className={`${i % 2 === 0 ? 'bg-white' : 'bg-[#F9F7F4]'} ${row.age === 35 ? 'ring-2 ring-inset ring-[#D97642]/30' : ''}`}>
                    <td className="px-5 py-4 font-bold text-[#1A3A52]">
                      Age {row.age}
                      {row.age === 35 && <span className="ml-2 px-2 py-0.5 bg-[#D97642] text-white text-xs font-bold rounded-full">Most Popular</span>}
                    </td>
                    <td className="px-5 py-4 text-center text-gray-700 font-semibold">{row.r10}</td>
                    <td className="px-5 py-4 text-center font-bold text-[#D97642]">{row.r20}</td>
                    <td className="px-5 py-4 text-center text-gray-700 font-semibold">{row.r30}</td>
                    <td className="px-5 py-4 text-sm text-gray-500">{row.savings}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <p className="text-xs text-gray-400 mt-3 text-center">Rates are estimates for Preferred health class, male, non-smoker, Banner Life. Actual rates vary. April 2026.</p>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-20 bg-[#F9F7F4]">
        <div className="max-w-3xl mx-auto px-4 sm:px-8">
          <div className="text-center mb-10">
            <h2 className="text-3xl md:text-4xl font-extrabold text-[#1A3A52] mb-4">Term Life Insurance Rates FAQ — Indianapolis</h2>
          </div>
          <div className="space-y-3">
            {faqs.map((faq, i) => (
              <div key={i} className="bg-white rounded-xl border border-gray-100 overflow-hidden">
                <button onClick={() => setOpenFaq(openFaq === i ? null : i)} className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer">
                  <span className="font-semibold text-[#1A3A52] pr-4 text-sm">{faq.q}</span>
                  <i className={`ri-arrow-down-s-line text-[#D97642] text-xl flex-shrink-0 transition-transform ${openFaq === i ? 'rotate-180' : ''}`}></i>
                </button>
                {openFaq === i && <div className="px-6 pb-5 text-sm text-gray-600 leading-relaxed border-t border-gray-100 pt-4">{faq.a}</div>}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-[#1A3A52]">
        <div className="max-w-3xl mx-auto px-4 sm:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-4">Get Your Exact Indianapolis Term Life Rate</h2>
          <p className="text-white/75 mb-8 text-lg">We compare 20+ carriers — not just 5. Get your personalized rate in minutes. Free, no obligation.</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="/book-appointment" className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-[#D97642] text-white font-bold rounded-full hover:bg-[#C26638] transition-all whitespace-nowrap">
              <i className="ri-calendar-check-fill text-lg"></i>
              Book My Free Rate Comparison
            </a>
            <a href="tel:+13176482983" className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white/10 text-white font-bold rounded-full hover:bg-white/20 transition-all border border-white/30 whitespace-nowrap">
              <i className="ri-phone-fill text-lg"></i>
              Call (317) 648-2983
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
